import { useSitecore } from '@sitecore-content-sdk/nextjs';
import { BreadcrumbData } from 'lib/page-props-factory/plugins/breadcrumb';

export function useBreadcrumbData(): BreadcrumbData | null {
  const { page } = useSitecore();
  const sitecoreContext = page?.layout?.sitecore?.context as Record<string, unknown> | undefined;
  return (sitecoreContext?.breadcrumbData as BreadcrumbData) || null;
}
